var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isLoading && !_vm.forCanvas
      ? _c("h5", { staticClass: "mb-2" }, [
          _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoading
      ? _c("div", [
          _vm.type === "default" && _vm.detailComponent.summary_block
            ? _c("div", { staticClass: "wrap-summary-block" }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  _vm._l(_vm.detailComponent.summary_block, function(
                    data,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "container-summary-block",
                        style: _vm.styleDivBlock(data)
                      },
                      [
                        _c("div", { staticClass: "item-name" }, [
                          _vm._v(_vm._s(data.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-count" }, [_vm._v("0")])
                      ]
                    )
                  })
                )
              ])
            : _vm.type !== "default" && _vm.detailComponent.summary_block
            ? _c("div", { staticClass: "wrap-summary-block" }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  _vm._l(_vm.detailComponent.summary_block, function(
                    data,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "container-summary-block",
                        class: _vm.setClassSummary(data.type),
                        style: _vm.setStyleSummary(data.color, index)
                      },
                      [
                        _c("div", { staticClass: "item-name" }, [
                          _vm._v(_vm._s(data.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "item-count" }, [_vm._v("0")])
                      ]
                    )
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center mb-2" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form m__r--5",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus fa-lg" }),
                    _vm._v(" Add\n        ")
                  ]
                ),
                _vm._v(" "),
                _vm.type === "default"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn grey btn-import-form m__r--5",
                        attrs: { disabled: "" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-cloud-upload fa-lg" }),
                        _vm._v(" Import\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "default"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn grey btn-import-form m__r--5",
                        attrs: { disabled: "" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-download fa-lg" }),
                        _vm._v(" Export\n        ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "btn grey btn-import-form",
                    attrs: { disabled: "" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-filter fa-lg" }),
                    _vm._v(" Filter\n        ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.detailComponent.columns &&
            _vm.detailComponent.columns.length > 0
              ? _c("div", { staticClass: "columns" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    _vm._l(_vm.detailComponent.columns, function(data, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "column" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "header-list",
                              staticStyle: { cursor: "default !important" }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/icon/column-type/" +
                                    _vm.setIconType(data.type) +
                                    ".svg")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "separator" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "column-name" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(data.name) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(4, function(index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "column-preview",
                                class: {
                                  "bg-gray": index === 2 || index === 4
                                },
                                staticStyle: { cursor: "default !important" }
                              },
                              [_c("div", { staticClass: "content-preview" })]
                            )
                          })
                        ],
                        2
                      )
                    })
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.detailComponent.columns ||
            _vm.detailComponent.columns.length === 0
              ? _c("p", { staticClass: "text-empty-data-component" }, [
                  _vm._v("\n        No Column On This Component\n      ")
                ])
              : _vm._e()
          ])
        ])
      : _c("div", { staticClass: "skeleton-component" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa33017c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa33017c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyTableView.vue
// module id = null
// module chunks = 